"use client"
import { cx } from "@/utils/cx"
import { Component } from "@/types/types"

import { BrandMark } from "@/ui/atoms/branding/BrandMark"
import { BrandTagline } from "@/ui/atoms/branding/BrandTagline"
import { TextLink } from "@/ui/atoms/controls/TextLink"
import { Stack } from "@/ui/atoms/layout/Stack"
import { SplashLayout } from "@/ui/layouts/SplashLayout"

import { SignInForm } from "./_sections/SignInForm"
import { useTrackPageView } from "@/hooks/_archive/global/analytics/useTrackPageView"
import { User } from "@/schemas/User"
import { useSetCurrentUser } from "@/hooks/account/useSetCurrentUser"
import { trackEvent } from "@/actions/_archive/global/analytics/trackEvent"

export const COMPONENT_NAME = "signInView"

export const presets = {}

export interface Props extends Component {}

export function SignInView({ className, testId = COMPONENT_NAME }: Props) {
  const setCurrentUser = useSetCurrentUser()

  function handleSuccess(newCurrentUser: User, redirectTo?: string) {
    setCurrentUser(newCurrentUser)
    trackEvent("login")
    // force a page reload to reinstantiate the session & data store
    if (redirectTo) {
      window.location.href = redirectTo
    } else {
      window.location.href = "/course"
    }
  }

  useTrackPageView("Sign in")

  return (
    <SplashLayout className={className} testId={testId}>
      <Stack className={cx("gap-8 w-full max-w-[480px] text-text")}>
        <header>
          <Stack className="gap-2 items-center">
            <TextLink href="/" testId="brandLink">
              <BrandMark className="w-[220px] h-auto" />
            </TextLink>
            <BrandTagline className="text-center" />
          </Stack>
        </header>
        <main>
          <SignInForm onSuccess={handleSuccess} />
        </main>
      </Stack>
    </SplashLayout>
  )
}
